import React, { useEffect } from 'react';
import { formatText } from 'core/i18n';
import BoxTabs from 'components/newAccountSteps/profileSteps/profileStep3/BoxTabs/BoxTabs';
import { recordIdentityEvent } from 'utilities/uTagging';
import { VIDEO_CALL, VIDEO_SELFIE } from 'constants/identityMethod';
import { EVENT_ONBOARDING } from 'constants/uTagConstants/RAConstants';
import { IDENTITY_CONST, IDENTITY_VIDEOS_RECORD_TAG } from 'constants/uTagConstants/paths';
import propTypes from 'prop-types';

export const VideoTabbedBox = ({ selectedItemIndex, handleTabChange }) => {
    const onTabChange = selectedItemIndex => {
        handleTabChange(selectedItemIndex);
        recordIdentityEvent(
            EVENT_ONBOARDING,
            IDENTITY_CONST,
            `${
                selectedItemIndex === 0
                    ? IDENTITY_VIDEOS_RECORD_TAG[VIDEO_SELFIE]
                    : IDENTITY_VIDEOS_RECORD_TAG[VIDEO_CALL]
            }`
        );
    };

    useEffect(() => {
        onTabChange(selectedItemIndex);
    }, []);

    return (
        <div className="video-description">
            <div className="identification-tab-box">
                <BoxTabs callBack={onTabChange} styleTabs={'square-pills'} selectedTab={selectedItemIndex}>
                    {[formatText('identification-videoSelfieOption'), formatText('identification-videoCallOption')]}
                </BoxTabs>
            </div>
        </div>
    );
};

VideoTabbedBox.propTypes = {
    selectedItemIndex: propTypes.number,
    handleTabChange: propTypes.func,
};
